class VariantUpdater {
  static VARIANTS_METAFIELDS_CACHE = null;

  constructor(variantId) {
    this.variantId = variantId;
  }

  static isVariantImageEnabled() {
    const variantImageElement = document.querySelector('[data-is-variant-image-enable]');
    return variantImageElement && variantImageElement.getAttribute('data-is-variant-image-enable') === 'true';
  }

  static async updateWhyToBuySection(variantInformation){
    const whyToBuyText = variantInformation['why_to_buy'];
    const isText = Boolean(whyToBuyText);

    const $whyToBuySection = document.querySelector('[why-to-buy-section]');
    if($whyToBuySection){
      $whyToBuySection.querySelector('[why-to-buy-text]').innerHTML = whyToBuyText;
      $whyToBuySection.classList.toggle('hidden', !isText)
    }
  }

  static async updateSEOInformation(variantInformation, variantDefaults, variantId){
    const metaTitle = variantInformation['meta_title'] || variantDefaults['meta_title'];
    const metaDescription = variantInformation['meta_description'] || variantDefaults['meta_description'];

    document.title = metaTitle;
    const metaDescriptionElement = document.querySelector('meta[name="description"]')
    if(metaDescriptionElement){
      metaDescriptionElement.setAttribute('content', metaDescription);
    }
    const canonicalElement = document.querySelector('link[rel="canonical"]');
    if(canonicalElement){
      const currentCanonicalValue = canonicalElement.getAttribute('href');
      canonicalElement.setAttribute('href', currentCanonicalValue.replace(/variant=[0-9]+/, `variant=${variantId}`) )
    }
  }

  static async updateVariantTitle(variantInformation, product){
    const handle = product['handle'];
    const options = product['options'];
    const productTitle = product['title'];

    const metaScentName = variantInformation['scent'] || false;
    let secondTitle = variantInformation['option_2'] || false;
    let prefixTitle = '';
    const isSecondOptionBenefit = (options[1] ?? '') == 'Benefit';

    //updating scent title
    if(handle == 'whole-body-deodorant' && secondTitle == 'Stick'){
      prefixTitle = 'Sensitive';
    }
    else if(isSecondOptionBenefit){
      prefixTitle = secondTitle;
      secondTitle = '';
      if(productTitle.includes('Moisturizer') && prefixTitle == 'Moisturizing'){
        prefixTitle = ''
      }
    }

    document.querySelectorAll('[scent-title]').forEach($scentTitle => {
      if(metaScentName){
        $scentTitle.classList.remove('hidden');
        $scentTitle.innerText = metaScentName;
      }
      else{
        $scentTitle.classList.add('hidden');
      }
    });

    document.querySelectorAll('[product-title-prefix]').forEach($productPrefixTitle => {
      $productPrefixTitle.innerText = prefixTitle;
      $productPrefixTitle.classList.toggle('hidden', !prefixTitle);
    });

    document.querySelectorAll('[variant-title]').forEach($variantTitle => {
      if(secondTitle){
        $variantTitle.classList.remove('hidden');
        $variantTitle.innerText = secondTitle
      }else{
        $variantTitle.classList.add('hidden');
        $variantTitle.innerText = '';
      }
    });

    const scentFamilyElement = document.querySelector('.product-section-scent-family');
    if(scentFamilyElement){
      scentFamilyElement.innerText = scentFamily;
    }
  }

  static async updateBreadcrumb(variantInformation, productInfo){
    const collectionTitle = variantInformation["breadcrumb"]["name"] ?? productInfo["breadcrumb"]["name"];
    const collectionUrl = variantInformation["breadcrumb"]["url"] ?? productInfo["breadcrumb"]["url"];

    if(collectionTitle){
      const $breadcrumb = document.querySelector("[breadcrumb-collection]");
      if($breadcrumb){
        $breadcrumb.innerText = collectionTitle;
        $breadcrumb.setAttribute('href', collectionUrl);
        $breadcrumb.parentNode.style.removeProperty('display');
      }
      else{
        $breadcrumb.parentNode.style.diplay = 'none';
      }
    }
  }

  static async updateBreadcrumbProduct(){
    document.querySelector('[breadcrumb-product]').innerText = document.querySelector('h1').innerText.replace('\n', ' ');
  }

  static updateVariantMetaInformation(variantId){
    if (!variantId) {
      console.warn('updateVariantMetaInformation(n: variantId is not provided or invalid.');
      return; // Early exit if variantId is null, undefined, or invalid
    }

    VariantUpdater.getVariantsMetaInformation().then(variantsMetafields => {
      const variantInformation = variantsMetafields[variantId];
      const variantDefaults = variantsMetafields['default'];
      const product = variantsMetafields['product'];

      VariantUpdater.updateWhyToBuySection(variantInformation);
      VariantUpdater.updateSEOInformation(variantInformation, variantDefaults, variantId);
      VariantUpdater.updateVariantTitle(variantInformation, product).then(VariantUpdater.updateBreadcrumbProduct);
      VariantUpdater.updateBreadcrumb(variantInformation, product);
    }).catch(error => {
      throw error
    });
  }

  static updateVariantMetaInformationOnModal(variantId){
    if (!variantId) {
      console.warn('updateVariantMetaInformationOnModal: variantId is not provided or invalid.');
      return; // Early exit if variantId is null, undefined, or invalid
    }

    // Get the JSON data from the product-variant-metafield script.
    const variantMetafieldData = document.querySelector('[data-variant-metafield-json-data]');
    let variantsMetafields = {};
    if (variantMetafieldData) {
      try {
        variantsMetafields = JSON.parse(variantMetafieldData.textContent);
      } catch (e) {
        console.error('Failed to parse variant metafields JSON:', e);
      }
    }

    const variantInformation = variantsMetafields[variantId];
    const variantDefaults = variantsMetafields['default'];
    const product = variantsMetafields['product'];

    VariantUpdater.updateVariantTitle(variantInformation, variantDefaults, product);

    // TODO: Update the modal with the new variant information (If required). Scent, weight, keywords, etc.
  }

  static async getVariantsMetaInformation(){
    if(VariantUpdater.VARIANTS_METAFIELDS_CACHE !== null){
      return VariantUpdater.VARIANTS_METAFIELDS_CACHE;
    }
    return fetch(document.location.pathname + "?sections=variants-metafields")
      .then(res =>  res.json()).then(sections => {
        if(sections['variants-metafields']){
          const container = document.createElement('div');
          container.innerHTML = sections['variants-metafields']
          VariantUpdater.VARIANTS_METAFIELDS_CACHE = JSON.parse(container.querySelector('div').innerText);
        }
        return VariantUpdater.VARIANTS_METAFIELDS_CACHE
      });
  }
}